import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMakkelijk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 34c7.732 0 14-6.268 14-14S27.732 6 20 6 6 12.268 6 20s6.268 14 14 14"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m19.904 23.603 8.86-17.721 4.472 2.236-11 22-4.43.08-6-11 4.389-2.395z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m30.104 19.03-5.3 10.27H20.1v-1h4.095l5.02-9.73z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMakkelijk);

export default ForwardRef;
